import { render, staticRenderFns } from "./lists_edit.vue?vue&type=template&id=a5ccb49c&scoped=true&"
import script from "./lists_edit.vue?vue&type=script&lang=ts&"
export * from "./lists_edit.vue?vue&type=script&lang=ts&"
import style0 from "./lists_edit.vue?vue&type=style&index=0&id=a5ccb49c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ccb49c",
  null
  
)

export default component.exports